<template>
	<div class="kind_anime">
		<div class="films">{{ name }}</div>
	</div>
</template>

<script>


export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>

<style type="text/css">
	.kind_anime{
		display: inline-block;
	}

	.kind_anime .films{
		margin: 0 5px;
		background: #262626;
		border-radius: 5px;
		padding: 10px 20px;
		color: white;
		cursor: pointer;
		font-weight: bold;
	}
</style>